// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recoveryContractModificationComponent {
  background-color: #f3f4f6;
  height: 100vh;
  padding: 0 42px 60px 42px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
}
.recoveryContractModificationComponent .container {
  width: 80%;
  margin: auto;
}
.recoveryContractModificationComponent .container .breadCrumb {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #868686;
}
.recoveryContractModificationComponent .container .breadCrumb .mainScreen,
.recoveryContractModificationComponent .container .breadCrumb .secondScreen {
  display: inline-block;
  margin-right: 10px;
}
.recoveryContractModificationComponent .container .breadCrumb .secondScreen {
  margin-left: 10px;
}
.recoveryContractModificationComponent .container .nameContainer {
  display: flex;
  flex-direction: row;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  margin-top: 10px;
}
.recoveryContractModificationComponent .container .nameContainer .image {
  background: #c1c1c1;
  border: 1px solid #c1c1c1;
  color: white;
  height: 60px;
  width: 60px;
  border-radius: 30px;
  padding-top: 4px;
  padding-left: 6px;
  text-align: center;
  font-weight: 500;
  font-size: 24px;
  line-height: 34px;
  display: flex;
  align-items: center;
}
.recoveryContractModificationComponent .container .nameContainer .nameText {
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #333333;
  position: relative;
  top: 10px;
  left: 10px;
}
.recoveryContractModificationComponent .container .cardContainer {
  margin: 24px 32px;
  margin-left: 10px;
  background: #ffffff;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  display: flex;
  flex-direction: row;
}
.recoveryContractModificationComponent .container .cardContainer .leftContainer {
  padding: 32px;
  width: 70%;
}
.recoveryContractModificationComponent .container .cardContainer .leftContainer .titleBar {
  display: flex;
  flex-direction: row;
}
.recoveryContractModificationComponent .container .cardContainer .leftContainer .titleBar .title {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #333333;
  margin-right: 12px;
  position: relative;
  bottom: 2px;
}
.recoveryContractModificationComponent .container .cardContainer .leftContainer .titleRow {
  margin-top: 33px;
  display: flex;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.recoveryContractModificationComponent .container .cardContainer .leftContainer .titleRow .firstTitle {
  width: 51%;
}
.recoveryContractModificationComponent .container .cardContainer .leftContainer .titleRow .secondTitle {
  width: 49%;
}
.recoveryContractModificationComponent .container .cardContainer .leftContainer .dateRow {
  display: flex;
  flex-direction: row;
  align-content: space-between;
}
.recoveryContractModificationComponent .container .cardContainer .leftContainer .dateRow .datePicker {
  width: 100%;
}
.recoveryContractModificationComponent .container .cardContainer .leftContainer .percentageInputRow {
  margin-top: 32px;
  display: flex;
  flex-direction: column;
}
.recoveryContractModificationComponent .container .cardContainer .leftContainer .percentageInputRow .header {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.recoveryContractModificationComponent .container .cardContainer .leftContainer .percentageInputRow .container {
  width: 100%;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  display: flex;
  height: 56px;
  flex-direction: row;
}
.recoveryContractModificationComponent .container .cardContainer .leftContainer .percentageInputRow .container .labelText {
  border-right: 1px solid #e9e9e9;
  background: #fafafa;
  width: 19%;
  border-radius: 8px 0px 0px 8px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #333333;
  padding: 16px;
}
.recoveryContractModificationComponent .container .cardContainer .leftContainer .percentageInputRow .container .inputBox {
  padding: 16px;
  display: flex;
  width: 81%;
  justify-content: space-between;
}
.recoveryContractModificationComponent .container .cardContainer .leftContainer .percentageInputRow .container .inputBox input {
  border: none;
  width: 98%;
}
.recoveryContractModificationComponent .container .cardContainer .leftContainer .percentageInputRow .container .inputBox input:focus-visible {
  outline: none;
}
.recoveryContractModificationComponent .container .cardContainer .rightContainer {
  width: 30%;
  border-left: 1px solid #f2f2f2;
  padding: 94px 32px 32px 32px;
}
.recoveryContractModificationComponent .container .cardContainer .rightContainer .title {
  margin-top: 20px;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.recoveryContractModificationComponent .container .cardContainer .rightContainer .description {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #999999;
}`, "",{"version":3,"sources":["webpack://./src/screens/recoveryContractModification/recoveryContractModification.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,aAAA;EACA,yBAAA;EAEA,iCAAA;EACA,kBAAA;AAAJ;AAEI;EACI,UAAA;EACA,YAAA;AAAR;AAEQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAAZ;AAEY;;EAEI,qBAAA;EACA,kBAAA;AAAhB;AAGY;EACI,iBAAA;AADhB;AAKQ;EACI,aAAA;EACA,mBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;AAHZ;AAKY;EACI,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AAHhB;AAMY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AAJhB;AAQQ;EACI,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AANZ;AAQY;EACI,aAAA;EACA,UAAA;AANhB;AAQgB;EACI,aAAA;EACA,mBAAA;AANpB;AAQoB;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EAEA,WAAA;AAPxB;AAWgB;EACI,gBAAA;EACA,aAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AATpB;AAUoB;EACI,UAAA;AARxB;AAWoB;EACI,UAAA;AATxB;AAagB;EACI,aAAA;EACA,mBAAA;EACA,4BAAA;AAXpB;AAaoB;EACI,WAAA;AAXxB;AAegB;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;AAbpB;AAeoB;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAbxB;AAgBoB;EACI,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;AAdxB;AAgBwB;EACI,+BAAA;EACA,mBAAA;EACA,UAAA;EACA,8BAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;AAd5B;AAiBwB;EACI,aAAA;EACA,aAAA;EACA,UAAA;EACA,8BAAA;AAf5B;AAiB4B;EACI,YAAA;EACA,UAAA;AAfhC;AAkB4B;EACI,aAAA;AAhBhC;AAuBY;EACI,UAAA;EACA,8BAAA;EACA,4BAAA;AArBhB;AAuBgB;EACI,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AArBpB;AAwBgB;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAtBpB","sourcesContent":[".recoveryContractModificationComponent {\n    background-color: #f3f4f6;\n    height: 100vh;\n    padding: 0 42px 60px 42px;\n\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n\n    .container {\n        width: 80%;\n        margin: auto;\n\n        .breadCrumb {\n            font-weight: 500;\n            font-size: 14px;\n            line-height: 20px;\n            color: #868686;\n\n            .mainScreen,\n            .secondScreen {\n                display: inline-block;\n                margin-right: 10px;\n            }\n\n            .secondScreen {\n                margin-left: 10px;\n            }\n        }\n\n        .nameContainer {\n            display: flex;\n            flex-direction: row;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            margin-top: 10px;\n\n            .image {\n                background: #c1c1c1;\n                border: 1px solid #c1c1c1;\n                color: white;\n                height: 60px;\n                width: 60px;\n                border-radius: 30px;\n                padding-top: 4px;\n                padding-left: 6px;\n                text-align: center;\n                font-weight: 500;\n                font-size: 24px;\n                line-height: 34px;\n                display: flex;\n                align-items: center;\n            }\n\n            .nameText {\n                font-weight: 700;\n                font-size: 28px;\n                line-height: 38px;\n                color: #333333;\n                position: relative;\n                top: 10px;\n                left: 10px;\n            }\n        }\n\n        .cardContainer {\n            margin: 24px 32px;\n            margin-left: 10px;\n            background: #ffffff;\n            box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n            border-radius: 8px;\n            display: flex;\n            flex-direction: row;\n\n            .leftContainer {\n                padding: 32px;\n                width: 70%;\n\n                .titleBar {\n                    display: flex;\n                    flex-direction: row;\n\n                    .title {\n                        font-family: 'Spoqa Han Sans Neo';\n                        font-style: normal;\n                        font-weight: 700;\n                        font-size: 20px;\n                        line-height: 30px;\n                        color: #333333;\n                        margin-right: 12px;\n                        position: relative;\n\n                        bottom: 2px;\n                    }\n                }\n\n                .titleRow {\n                    margin-top: 33px;\n                    display: flex;\n                    font-family: 'Spoqa Han Sans Neo';\n                    font-style: normal;\n                    font-weight: 700;\n                    font-size: 14px;\n                    line-height: 20px; \n                    color: #505054;\n                    .firstTitle {\n                        width: 51%;\n                    }\n\n                    .secondTitle {\n                        width: 49%;\n                    }\n                }\n\n                .dateRow {\n                    display: flex;\n                    flex-direction: row;\n                    align-content: space-between;\n\n                    .datePicker {\n                        width: 100%;\n                    }\n                }\n\n                .percentageInputRow {\n                    margin-top: 32px;\n                    display: flex;\n                    flex-direction: column;\n\n                    .header {\n                        font-family: 'Spoqa Han Sans Neo';\n                        font-style: normal;\n                        font-weight: 700;\n                        font-size: 14px;\n                        line-height: 20px;\n                        color: #505054;\n                    }\n\n                    .container {\n                        width: 100%;\n                        background: #ffffff;\n                        border: 1px solid #e9e9e9;\n                        border-radius: 8px;\n                        display: flex;\n                        height: 56px;\n                        flex-direction: row;\n\n                        .labelText {\n                            border-right: 1px solid #e9e9e9;\n                            background: #fafafa;\n                            width: 19%;\n                            border-radius: 8px 0px 0px 8px;\n                            font-family: 'Spoqa Han Sans Neo';\n                            font-style: normal;\n                            font-weight: 400;\n                            font-size: 16px;\n                            line-height: 24px;\n                            text-align: center;\n                            color: #333333;\n                            padding: 16px;\n                        }\n\n                        .inputBox {\n                            padding: 16px;\n                            display: flex;\n                            width: 81%;\n                            justify-content: space-between;\n\n                            input {\n                                border: none;\n                                width: 98%;\n                            }\n\n                            input:focus-visible {\n                                outline: none;\n                            }\n                        }\n                    }\n                }\n            }\n\n            .rightContainer {\n                width: 30%;\n                border-left: 1px solid #f2f2f2;\n                padding: 94px 32px 32px 32px;\n\n                .title {\n                    margin-top: 20px;\n                    font-weight: 700;\n                    font-size: 14px;\n                    line-height: 20px;\n                    color: #505054;\n                }\n\n                .description {\n                    font-style: normal;\n                    font-weight: 400;\n                    font-size: 12px;\n                    line-height: 18px;\n                    color: #999999;\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
